// extracted by mini-css-extract-plugin
export default {"closeButton":"styles_closeButton__94LDe","container":"styles_container__ieR1G"};